import React, { ReactNode } from 'react';
import { QueryCache, QueryClient, QueryClientProvider } from 'react-query';
import { notify } from './Notification';
import { isApiError } from './types';

const queryCache = new QueryCache();
const queryClient = new QueryClient({
  queryCache,
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      refetchOnReconnect: true,
      retry: false,
      staleTime: Infinity,
      onError: (error) => {
        if (!isApiError(error)) return;
        if (error.status === 401) return;
        if (!error.message) return;
        notify(error.message, 'error');
      },
    },
    mutations: {
      onError: (error) => {
        if (!isApiError(error)) return;
        if (error.status === 401) return;
        if (!error.message) return;
        notify(error.message, 'error');
      },
    },
  },
});

type QueryCacheProviderProps = {
  children: ReactNode;
};

export default function QueryCacheProvider({ children }: QueryCacheProviderProps) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
